import React from 'react';
import styled, {keyframes} from 'styled-components';
import {fadeIn} from 'react-animations';
const fadeInAnimation = keyframes`${fadeIn}`;

const ImageLoaderSpinner = styled.div`
      animation: 1s ${fadeInAnimation};
      width: 100%;
      height: 100%;
      position: absolute;
      z-index: 1;
  .double-bounce1, .double-bounce2 {
      width: 100%;
      height: 100%;
      border-radius: 50%;
      background-color: rgba(0,0,0,0.2);
      opacity: 0.6;
      position: absolute;
      top: 0;
      left: 0;
      
      -webkit-animation: sk-bounce 3.0s infinite ease-in-out;
      animation: sk-bounce 3.0s infinite ease-in-out;
    }
    
    .double-bounce2 {
      -webkit-animation-delay: -1.5s;
      animation-delay: -1.5s;
    }
    
    @-webkit-keyframes sk-bounce {
      0%, 100% { -webkit-transform: scale(0.0) }
      50% { -webkit-transform: scale(1.0) }
    }
    
    @keyframes sk-bounce {
      0%, 100% { 
        transform: scale(0.0);
        -webkit-transform: scale(0.0);
      } 50% { 
        transform: scale(1.0);
        -webkit-transform: scale(1.0);
      }
    }
`;

const Component = () => {
    return (<ImageLoaderSpinner>
        <div className="double-bounce1"/>
        <div className="double-bounce2"/>
    </ImageLoaderSpinner>);
};

export default Component;
